import { SidebarNavigationContainer, SidebarNavigationItem } from "@king-ict/eupisi-ui/components";
import { Match } from "@testing-library/react";
import { useTranslation } from "react-i18next";
import { useLocation, useRouteMatch } from "react-router";

import { useAuth } from "../../hooks";
import { Role } from "../../models/Shared/Role";
import { ClaimType } from "../../models/User";
import {
  institutionListRoute, institutionDetailsRoute,
  dashboardRoute, schoolYearListRoute, schoolCandidateRoute,
  institutionEditRoute,
  houseNumberInstitutionListRoute,
  schoolCandidateDetailRoute, schoolCandidateEditRoute,
  schoolCandidateInstitutionSummaryListRoute, schoolCandidateInstitutionListRoute,
  schoolCandidateInstitutionReassignmentRoute,
  schoolCandidateInstitutionAdminListRoute, schoolCandidateInstitutionAdminDetailRoute,
  schoolCandidateInstitutionAdminEditRoute,
  announcementListRoute, faqGroupListRoute, faqItemListRoute,
  announcementEditRoute, announcementDetailRoute, faqGroupDetailRoute, faqGroupEditRoute,
  faqItemDetailRoute, faqItemEditRoute,
  editImportantDateRoute,
  committeeListRoute, committeeEditRoute, committeeDetailRoute,
  committeeApprovalListRoute, committeeApprovalDetailRoute, committeeApprovalEditRoute,
  countyCommitteeListRoute, countyCommitteeDetailRoute, countyCommitteeEditRoute,
  ministryCommitteeListRoute, ministryCommitteeDetailRoute, ministryCommitteeEditRoute,
  userRoleRoute, roleListRoute, userListRoute, userDetailRoute, userEditRoute, userListUrl,
  requestListRoute, requestCreateRoute, requestEditRoute, requestDetailsRoute, requestInstitutionEditRoute,
  requestAdminRoute, requestAdminListRoute, requestAdminDetailsRoute, requestAdminSchoolCandidateCreateRoute,
  outsideEnrollmentAreaListRoute, outsideEnrollmentAreaEditRoute,
  languageCourseDecisionListRoute, languageCourseDecisionEditRoute,
  medicalExaminationEditRoute,
  languageCourseDecisionMinistryListRoute, languageCourseDecisionMinistryEditRoute,
  committeeDecisionDetailsRoute, committeeDecisionEditRoute, 
  decisionProposalEditRoute, form7EditRoute, enrollmentDecisionEditRoute,
  registrationFormListRoute, registrationFormEditRoute, registeredListRoute,
  faqGroupsAndItemsRoute, aboutProgramRoute, helpAndSupportRoute,
  newErrorReporRoute,   statementOfAccessibilityRoute
} from "../../routes/routes";
import AboutProgram from "../AboutProgram/AboutProgram";
import { AnnouncementDetails, AnnouncementEdit, AnnouncementList } from "../Announcement";
import {
  CommitteeList, CommitteeEdit, CommitteeDetails,
  CommitteeApprovalList, CommitteeApprovalDetails, CommitteeApprovalEdit,
  CountyCommitteeList, CountyCommitteeDetails, CountyCommitteeEdit,
  MinistryCommitteeList, MinistryCommitteeDetails, MinistryCommitteeEdit
} from "../Committee";
import { Dashboard } from "../Dashboard";
import { ErrorReportCreate } from "../ErrorReport/ErrorReportCreate";
import { Faq, FaqGroupDetails, FaqGroupEdit, FaqGroupList, FaqItemDetails, FaqItemEdit, FaqItemList } from "../Faq";
import HelpAndSupport from "../HelpAndSupport/HelpAndSupport";
import { HouseNumberInstitutionList } from "../HouseNumberInstitution";
import { InstitutionList } from "../Institutions";
import { InstitutionDetails } from "../Institutions/InstitutionDetails";
import { InstitutionEdit } from "../Institutions/InstitutionEdit";
import {
  RequestList, RequestCreate, RequestEdit, RequestInstitutionEdit,
  RequestAdminList, RequestDetails, RequestSchoolCandidateCreate,
  OutsideEnrollmentAreaList, OutsideEnrollmentAreaEdit,
  LanguageCourseDecisionList, LanguageCourseDecisionEdit,
  LanguageCourseDecisionMinistryList, MedicalExaminationEdit,
  CommitteeDecisionDetails, CommitteeDecisionEdit,
  DecisionProposalEdit, Form7Edit, EnrollmentDecisionEdit,
  RegistrationFormList, RegistrationFormEdit, RegistrationList
} from "../Request";
import {
  SchoolCandidateDetails, SchoolCandidateEdit, SchoolCandidateList,
  SchoolCandidateInstitutionSummaryList, SchoolCandidateInstitutionList,
  SchoolCandidateInstitutionReassignment, SchoolCandidateInstitutionAdminList } from "../SchoolCandidate";
import { ImportantDateList, SchoolYearList } from "../SchoolYear";
import { StatementOfAccessibility } from "../StatementOfAccessibility";
import { RoleList, UserList, UserDetails, UserEdit } from "../User";

export interface MatchParams {
  requestId: string;
  id: string;
}
export interface SidebarProps {
  sidebarIsOpen?: boolean
}

export function Sidebar({ sidebarIsOpen }: SidebarProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const auth = useAuth();

  const dashboardMatch = useRouteMatch<MatchParams>(dashboardRoute);
  const errorReportMatch = useRouteMatch<MatchParams>(newErrorReporRoute);

  const importantDateListMatch = useRouteMatch<MatchParams>(schoolYearListRoute);
  const importantDateEditMatch = useRouteMatch<MatchParams>(editImportantDateRoute);

  const schoolCandidateListMatch = useRouteMatch<MatchParams>(schoolCandidateRoute);
  const schoolCandidatedDetailsMatch = useRouteMatch<MatchParams>(schoolCandidateDetailRoute);
  const schoolCandidatedEditMatch = useRouteMatch<MatchParams>(schoolCandidateEditRoute);
  const schoolCandidateInstitutionSummaryListMatch = useRouteMatch<MatchParams>(schoolCandidateInstitutionSummaryListRoute);
  const schoolCandidateInstitutionListMatch = useRouteMatch<MatchParams>(schoolCandidateInstitutionListRoute);
  const schoolCandidateInstitutionReassignmentMatch = useRouteMatch<MatchParams>(schoolCandidateInstitutionReassignmentRoute);
  const schoolCandidateInstitutionAdminDetailsMatch = useRouteMatch<MatchParams>(schoolCandidateInstitutionAdminDetailRoute);
  const schoolCandidateInstitutionAdminEditMatch = useRouteMatch<MatchParams>(schoolCandidateInstitutionAdminEditRoute);

  const institutionListMatch = useRouteMatch<MatchParams>(institutionListRoute);
  const institutionDetailsMatch = useRouteMatch<MatchParams>(institutionDetailsRoute);
  const institutionEditMatch = useRouteMatch<MatchParams>(institutionEditRoute);
  const houseNumberInstitutionListMatch = useRouteMatch<MatchParams>(houseNumberInstitutionListRoute);

  const announcementListMatch = useRouteMatch<MatchParams>(announcementListRoute);
  const announcementDetailMatch = useRouteMatch<MatchParams>(announcementDetailRoute);
  const announcementEditMatch = useRouteMatch<MatchParams>(announcementEditRoute);

  const faqGroupListMatch = useRouteMatch<MatchParams>(faqGroupListRoute);
  const faqGroupDetailMatch = useRouteMatch<MatchParams>(faqGroupDetailRoute);
  const faqGroupEditMatch = useRouteMatch<MatchParams>(faqGroupEditRoute);

  const faqItemListMatch = useRouteMatch<MatchParams>(faqItemListRoute);
  const faqItemDetailMatch = useRouteMatch<MatchParams>(faqItemDetailRoute);
  const faqItemEditMatch = useRouteMatch<MatchParams>(faqItemEditRoute);

  const faqMatch = useRouteMatch<MatchParams>(faqGroupsAndItemsRoute);

  const committeeListMatch = useRouteMatch<MatchParams>(committeeListRoute);
  const committeeDetailMatch = useRouteMatch<MatchParams>(committeeDetailRoute);
  const committeeEditMatch = useRouteMatch<MatchParams>(committeeEditRoute);
  const committeeApprovalListMatch = useRouteMatch<MatchParams>(committeeApprovalListRoute);
  const committeeApprovalDetailsMatch = useRouteMatch<MatchParams>(committeeApprovalDetailRoute);
  const committeeApprovalEditMatch = useRouteMatch<MatchParams>(committeeApprovalEditRoute);
  const countyCommitteeListMatch = useRouteMatch<MatchParams>(countyCommitteeListRoute);
  const countyCommitteeDetailsMatch = useRouteMatch<MatchParams>(countyCommitteeDetailRoute);
  const countyCommitteeEditMatch = useRouteMatch<MatchParams>(countyCommitteeEditRoute);
  const ministryCommitteeListMatch = useRouteMatch<MatchParams>(ministryCommitteeListRoute);
  const ministryCommitteeDetailsMatch = useRouteMatch<MatchParams>(ministryCommitteeDetailRoute);
  const ministryCommitteeEditMatch = useRouteMatch<MatchParams>(ministryCommitteeEditRoute);

  const usersAndRolesListMatch = useRouteMatch<MatchParams>(userRoleRoute);
  const roleListMatch = useRouteMatch<MatchParams>(roleListRoute);
  const userListMatch = useRouteMatch<MatchParams>(userListRoute);
  const userDetailsMatch = useRouteMatch<MatchParams>(userDetailRoute);
  const userEditMatch = useRouteMatch<MatchParams>(userEditRoute);

  const requestListMatch = useRouteMatch<MatchParams>(requestListRoute);
  const requestCreateMatch = useRouteMatch<MatchParams>(requestCreateRoute);
  const requestEditMatch = useRouteMatch<MatchParams>(requestEditRoute);
  const requestDetailsMatch = useRouteMatch<MatchParams>(requestDetailsRoute);
  const requestInstitutionEditMatch = useRouteMatch<MatchParams>(requestInstitutionEditRoute);
  const requestAdminListMatch = useRouteMatch<MatchParams>(requestAdminListRoute);
  const requestAdminDetailsMatch = useRouteMatch<MatchParams>(requestAdminDetailsRoute);
  const requestAdminSchoolCandidateCreateMatch = useRouteMatch<MatchParams>(requestAdminSchoolCandidateCreateRoute);
  const committeeDecisionDetailsMatch = useRouteMatch<MatchParams>(committeeDecisionDetailsRoute);
  const committeeDecisionEditMatch = useRouteMatch<MatchParams>(committeeDecisionEditRoute);
  const decisionProposalEditMatch = useRouteMatch<MatchParams>(decisionProposalEditRoute);
  const form7EditMatch = useRouteMatch<MatchParams>(form7EditRoute);
  const medicalExaminationEditMatch = useRouteMatch<MatchParams>(medicalExaminationEditRoute);
  const enrollmentDecisionEditMatch = useRouteMatch<MatchParams>(enrollmentDecisionEditRoute);
  const outsideEnrollmentAreaListMatch = useRouteMatch<MatchParams>(outsideEnrollmentAreaListRoute);
  const outsideEnrollmentAreaEditMatch = useRouteMatch<MatchParams>(outsideEnrollmentAreaEditRoute);
  const languageCourseDecisionListMatch = useRouteMatch<MatchParams>(languageCourseDecisionListRoute);
  const languageCourseDecisionEditMatch = useRouteMatch<MatchParams>(languageCourseDecisionEditRoute);
  const languageCourseDecisionMinistryListMatch = useRouteMatch<MatchParams>(languageCourseDecisionMinistryListRoute);
  const languageCourseDecisionMinistryEditMatch = useRouteMatch<MatchParams>(languageCourseDecisionMinistryEditRoute);
  const registrationFormListMatch = useRouteMatch<MatchParams>(registrationFormListRoute);
  const registrationFormEditMatch = useRouteMatch<MatchParams>(registrationFormEditRoute);
  const registeredListMatch = useRouteMatch<MatchParams>(registeredListRoute);

  const getAdministrationItems = () => {
    let annouuncementRoute = "";
    let faqGroupRoute = "";
    let faqItemRoute = "";
    let annouuncementUrl = undefined;
    let faqGroupUrl = undefined;
    let faqItemUrl = undefined;
    let annouuncementRouteComponent = <></>;
    let faqGroupRouteComponent = <></>;
    let faqItemRouteComponent = <></>;


    if (announcementDetailMatch?.isExact) {
      annouuncementRoute = announcementDetailRoute;
      annouuncementUrl = announcementDetailMatch.url;
      annouuncementRouteComponent = <AnnouncementDetails />;
    } else if (announcementEditMatch?.isExact) {
      annouuncementRoute = announcementEditRoute;
      annouuncementUrl = announcementEditMatch.url;
      annouuncementRouteComponent = <AnnouncementEdit />;
    } else {
      annouuncementRoute = announcementListRoute;
      annouuncementRouteComponent = <AnnouncementList />;
    }

    if (faqGroupDetailMatch?.isExact) {
      faqGroupRoute = faqGroupDetailRoute;
      faqGroupUrl = faqGroupDetailMatch.url;
      faqGroupRouteComponent = <FaqGroupDetails />;
    } else if (faqGroupEditMatch?.isExact) {
      faqGroupRoute = faqGroupEditRoute;
      faqGroupUrl = faqGroupEditMatch.url;
      faqGroupRouteComponent = <FaqGroupEdit />;
    } else {
      faqGroupRoute = faqGroupListRoute;
      faqGroupRouteComponent = <FaqGroupList />;
    }


    if (faqItemDetailMatch?.isExact) {
      faqItemRoute = faqItemDetailRoute;
      faqItemUrl = faqItemDetailMatch.url;
      faqItemRouteComponent = <FaqItemDetails />;
    } else if (faqItemEditMatch?.isExact) {
      faqItemRoute = faqItemEditRoute;
      faqItemUrl = faqItemEditMatch.url;
      faqItemRouteComponent = <FaqItemEdit />;
    } else {
      faqItemRoute = faqItemListRoute;
      faqItemRouteComponent = <FaqItemList />;
    }

    return [

      <SidebarNavigationItem key="1"
        name={t("sidebar.announcementList")}
        route={annouuncementRoute}
        url={annouuncementUrl}
      >
        {annouuncementRouteComponent}
      </SidebarNavigationItem>,
      <SidebarNavigationItem key="2"
        name={t("sidebar.faqGroupList")}
        route={faqGroupRoute}
        url={faqGroupUrl}
      >
        {faqGroupRouteComponent}
      </SidebarNavigationItem>,
      <SidebarNavigationItem key="3"
        name={t("sidebar.faqItemList")}
        route={faqItemRoute}
        url={faqItemUrl}
      >
        {faqItemRouteComponent}
      </SidebarNavigationItem>,];
  };

  const getImportantDatesItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;


    if (importantDateEditMatch?.isExact) {
      route = editImportantDateRoute;
      url = importantDateEditMatch.url;
      routeComponent = <ImportantDateList />;
    }
    //  else if (institutionEditMatch?.isExact)
    // {
    //   route = institutionEditRoute;
    //   url = institutionEditMatch.url;
    //   routeComponent = <InstitutionEdit />;
    // }
    else {
      route = schoolYearListRoute;
      routeComponent = <SchoolYearList />;
    }

    return (
      <SidebarNavigationItem key="4"
        name={t("sidebar.importantDates")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getInstitutionItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;


    if (institutionDetailsMatch?.isExact) {
      route = institutionDetailsRoute;
      url = institutionDetailsMatch.url;
      routeComponent = <InstitutionDetails />;
    } else if (institutionEditMatch?.isExact) {
      route = institutionEditRoute;
      url = institutionEditMatch.url;
      routeComponent = <InstitutionEdit />;
    } else {
      route = institutionListRoute;
      routeComponent = <InstitutionList />;
    }

    return (
      <SidebarNavigationItem key="5"
        name={t("sidebar.institutionList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getHouseNumberInstitutionItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    //if (houseNumberInstitutionListMatch?.isExact) {
    route = houseNumberInstitutionListRoute;
    //url = houseNumberInstitutionListMatch.url;
    routeComponent = <HouseNumberInstitutionList />;
    //}

    return (
      <SidebarNavigationItem key="6"
        name={t("sidebar.houseNumberInstitutionList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getSchoolCandidateItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;


    if (schoolCandidatedDetailsMatch?.isExact) {
      route = schoolCandidateDetailRoute;
      url = schoolCandidatedDetailsMatch.url;
      routeComponent = <SchoolCandidateDetails />;
    } else if (schoolCandidatedEditMatch?.isExact) {
      route = schoolCandidateEditRoute;
      url = schoolCandidatedEditMatch.url;
      routeComponent = <SchoolCandidateEdit />;
    } else if (schoolCandidateInstitutionReassignmentMatch?.isExact) {
      route = schoolCandidateInstitutionReassignmentRoute;
      url = schoolCandidateInstitutionReassignmentMatch.url;
      routeComponent = <SchoolCandidateInstitutionReassignment />;
    } else {
      route = schoolCandidateRoute;
      routeComponent = <SchoolCandidateList />;
    }

    return (
      <SidebarNavigationItem key="7"
        name={t("sidebar.schoolCandidateUOList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getSchoolCandidateInstitutionSummaryItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (schoolCandidateInstitutionListMatch?.isExact) {
      route = schoolCandidateInstitutionListRoute;
      url = schoolCandidateInstitutionListMatch.url;
      routeComponent = <SchoolCandidateInstitutionList />;
    } else {
      //if (schoolCandidateInstitutionSummaryListMatch?.isExact) {
      route = schoolCandidateInstitutionSummaryListRoute;
      //url = schoolCandidateInstitutionSummaryListMatch.url;
      routeComponent = <SchoolCandidateInstitutionSummaryList />;
    }

    return (
      <SidebarNavigationItem key="8"
        name={t("sidebar.schoolCandidateInstitutionSummary")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };

  const getSchoolCandidateInstitutionList = () => {
    let route ="";
    let url = undefined;
    let routeComponent = <></>;

    if (schoolCandidateInstitutionAdminDetailsMatch?.isExact) {
      route = schoolCandidateInstitutionAdminDetailRoute;
      url = schoolCandidateInstitutionAdminDetailsMatch.url;
      routeComponent = <SchoolCandidateDetails />;
    } else if (schoolCandidateInstitutionAdminEditMatch?.isExact) {
      route = schoolCandidateInstitutionAdminEditRoute;
      url = schoolCandidateInstitutionAdminEditMatch.url;
      routeComponent = <SchoolCandidateEdit />;
    } else {
      route = schoolCandidateInstitutionAdminListRoute;       
      routeComponent = <SchoolCandidateInstitutionAdminList />;
    }

    return (
      <SidebarNavigationItem key="23"
        name={t("sidebar.schoolCandidateInstitutionAdminList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (committeeEditMatch?.isExact) {
      route = committeeEditRoute;
      url = committeeEditMatch.url;
      routeComponent = <CommitteeEdit />;
    } else if (committeeDetailMatch?.isExact) {
      route = committeeDetailRoute;
      url = committeeDetailMatch.url;
      routeComponent = <CommitteeDetails />;
    } else {
      route = committeeListRoute;
      routeComponent = <CommitteeList />;
    }

    return (
      <SidebarNavigationItem key="9"
        name={t("sidebar.committeeInstitution")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getCommitteeApprovalItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (committeeApprovalEditMatch?.isExact) {
      route = committeeApprovalEditRoute;
      url = committeeApprovalEditMatch.url;
      routeComponent = <CommitteeApprovalEdit />;
    } else if (committeeApprovalDetailsMatch?.isExact) {
      route = committeeApprovalDetailRoute;
      url = committeeApprovalDetailsMatch.url;
      routeComponent = <CommitteeApprovalDetails />;
    } else {
      //if (committeeApprovalListMatch?.isExact) {
      route = committeeApprovalListRoute;
      //url = committeeApprovalListMatch.url;
      routeComponent = <CommitteeApprovalList />;
    }

    return (
      <SidebarNavigationItem key="10"
        name={t("sidebar.committeeApprovalList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getCountyCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (countyCommitteeEditMatch?.isExact) {
      route = countyCommitteeEditRoute;
      url = countyCommitteeEditMatch.url;
      routeComponent = <CountyCommitteeEdit />;
    } else if (countyCommitteeDetailsMatch?.isExact) {
      route = countyCommitteeDetailRoute;
      url = countyCommitteeDetailsMatch.url;
      routeComponent = <CountyCommitteeDetails />;
    } else {
      //if (committeeApprovalListMatch?.isExact) {
      route = countyCommitteeListRoute;
      //url = committeeApprovalListMatch.url;
      routeComponent = <CountyCommitteeList />;
    }

    return (
      <SidebarNavigationItem key="11"
        name={t("sidebar.countyCommitteeList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getMinistryCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (ministryCommitteeEditMatch?.isExact) {
      route = ministryCommitteeEditRoute;
      url = ministryCommitteeEditMatch.url;
      routeComponent = <MinistryCommitteeEdit />;
    } else if (ministryCommitteeDetailsMatch?.isExact) {
      route = ministryCommitteeDetailRoute;
      url = ministryCommitteeDetailsMatch.url;
      routeComponent = <MinistryCommitteeDetails />;
    } else {
      //if (committeeApprovalListMatch?.isExact) {
      route = ministryCommitteeListRoute;
      //url = committeeApprovalListMatch.url;
      routeComponent = <MinistryCommitteeList />;
    }

    return (
      <SidebarNavigationItem key="12"
        name={t("sidebar.ministryCommitteeList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getUsersRolesItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (userEditMatch?.isExact) {
      route = userEditRoute;
      url = userEditMatch.url;
      routeComponent = <UserEdit />;
    } else if (userDetailsMatch?.isExact) {
      route = userDetailRoute;
      url = userDetailsMatch.url;
      routeComponent = <UserDetails />;
    } else {
      route = userListUrl();
      routeComponent = <UserList />;
    }

    return (
      <SidebarNavigationItem key="13"
        name={t("sidebar.users")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRequestItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (requestCreateMatch?.isExact) {
      route = requestCreateRoute;
      url = requestCreateMatch.url;
      routeComponent = <RequestCreate />;
    } else if (requestEditMatch?.isExact) {
      route = requestEditRoute;
      url = requestEditMatch.url;
      routeComponent = <RequestEdit />;
    } else if (requestDetailsMatch?.isExact) {
      route = requestDetailsRoute;
      url = requestDetailsMatch.url;
      routeComponent = <RequestDetails />;
    } else {
      route = requestListRoute;
      routeComponent = <RequestList />;
    }

    return (
      <SidebarNavigationItem key="14"
        name={t("sidebar.requestListItems")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRequestAdminItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (requestAdminDetailsMatch?.isExact) {
      route = requestAdminDetailsRoute;
      url = requestAdminDetailsMatch.url;
      routeComponent = <RequestDetails />;
    } else if (requestAdminSchoolCandidateCreateMatch?.isExact) {
      route = requestAdminSchoolCandidateCreateRoute;
      url = requestAdminSchoolCandidateCreateMatch.url;
      routeComponent = <RequestSchoolCandidateCreate />;
    } else if (requestInstitutionEditMatch?.isExact) {
      route = requestInstitutionEditRoute;
      url = requestInstitutionEditMatch.url;
      routeComponent = <RequestInstitutionEdit />;
    } else if (committeeDecisionEditMatch?.isExact) {
      route = committeeDecisionEditRoute;
      url = committeeDecisionEditMatch.url;
      routeComponent = <CommitteeDecisionEdit />;
    } else if (committeeDecisionDetailsMatch?.isExact) {
      route = committeeDecisionDetailsRoute;
      url = committeeDecisionDetailsMatch.url;
      routeComponent = <CommitteeDecisionDetails />;
    } else if (decisionProposalEditMatch?.isExact) {
      route = decisionProposalEditRoute;
      url = decisionProposalEditMatch.url;
      routeComponent = <DecisionProposalEdit />;
    } else if (form7EditMatch?.isExact) {
      route = form7EditRoute;
      url = form7EditMatch.url;
      routeComponent = <Form7Edit />;
    } else if (enrollmentDecisionEditMatch?.isExact) {
      route = enrollmentDecisionEditRoute;
      url = enrollmentDecisionEditMatch.url;
      routeComponent = <EnrollmentDecisionEdit />;
    } else if (medicalExaminationEditMatch?.isExact) {
      route = medicalExaminationEditRoute;
      url = medicalExaminationEditMatch.url;
      routeComponent = <MedicalExaminationEdit />;
    } else {
      route = requestAdminListRoute;
      routeComponent = <RequestAdminList />;
    }

    return (
      <SidebarNavigationItem key="91"
        name={t("sidebar.requestAdminList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getOutsideEnrollmentAreaItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (outsideEnrollmentAreaEditMatch?.isExact) {
      route = outsideEnrollmentAreaEditRoute;
      url = outsideEnrollmentAreaEditMatch.url;
      routeComponent = <OutsideEnrollmentAreaEdit />;
    } else {
      route = outsideEnrollmentAreaListRoute;
      routeComponent = <OutsideEnrollmentAreaList />;
    }

    return (
      <SidebarNavigationItem key="92"
        name={t("sidebar.outsideEnrollmentAreaList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getLanguageCourseDecisionItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;
	
    if (languageCourseDecisionEditMatch?.isExact) {
      route = languageCourseDecisionEditRoute;
      url = languageCourseDecisionEditMatch.url;
      routeComponent = <LanguageCourseDecisionEdit />;
    } else {
      route = languageCourseDecisionListRoute;
      routeComponent = <LanguageCourseDecisionList />;
    }

    return (
      <SidebarNavigationItem key="93"
        name={t("sidebar.languageCourseDecisionList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getLanguageCourseDecisionMinistryItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;
	
    if (languageCourseDecisionMinistryEditMatch?.isExact) {
      route = languageCourseDecisionMinistryEditRoute;
      url = languageCourseDecisionMinistryEditMatch.url;
      routeComponent = <LanguageCourseDecisionEdit />;
    } else {
      route = languageCourseDecisionMinistryListRoute;
      routeComponent = <LanguageCourseDecisionMinistryList />;
    }

    return (
      <SidebarNavigationItem key="96"
        name={t("sidebar.languageCourseDecisionMinistryList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRegistrationFormItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (registrationFormEditMatch?.isExact) {
      route = registrationFormEditRoute;
      url = registrationFormEditMatch.url;
      routeComponent = <RegistrationFormEdit />;
    } else {
      route = registrationFormListRoute;
      routeComponent = <RegistrationFormList />;
    }

    return (
      <SidebarNavigationItem key="94"
        name={t("sidebar.enrolledSchoolCandidateList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRegistrationItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    // if (registrationFormEditMatch?.isExact) {
    //   route = registrationFormEditRoute;
    //   url = registrationFormEditMatch.url;
    //   routeComponent = <RegistrationFormEdit />;
    // } else {
      route = registeredListRoute;
      routeComponent = <RegistrationList />;
    // }

    return (
      <SidebarNavigationItem key="95"
        name={t("sidebar.finalSchoolCandidateList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };

  return (
    <>
      <h4>{ }</h4>
      <SidebarNavigationContainer
        color="primary"
        size="2"
        sidebarIsOpen={sidebarIsOpen}
        sidebarShowHamburger={false}
      >
        {/*DASHBOARS */}
        <SidebarNavigationItem key="15"
          name={t("sidebar.dashboard")}
          route={dashboardRoute}
          url={"/dashboard"}
        >
          <Dashboard />
        </SidebarNavigationItem>
        {/*KLJUČNI DATUMI */}
          <SidebarNavigationItem key="16"
            name={t("sidebar.importantDates")}
            route={schoolYearListRoute}
            url={"/school-years"}
          >
            {getImportantDatesItems()}
          </SidebarNavigationItem>
        {/*ŠKOLSKI OBVEZNICI */}
        {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
          || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader
          || auth.currentRole?.role === Role.InstitutionAdministrator || auth.currentRole?.role === Role.InstitutionPrincipal) &&
          <SidebarNavigationItem key="17"
            name={t("sidebar.schoolCandidateList")}
            expanded={pathname.startsWith(schoolCandidateRoute)}
          >
          {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
            || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader) &&
            [getSchoolCandidateItems(),
            getSchoolCandidateInstitutionSummaryItems()]
          }
          {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
            || auth.currentRole?.role === Role.InstitutionAdministrator || auth.currentRole?.role === Role.InstitutionPrincipal) &&
            
            getSchoolCandidateInstitutionList()
            
          }
          </SidebarNavigationItem>
        }
        {/*USTANOVE*/}
        {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
          || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader
          || auth.currentRole?.role === Role.InstitutionAdministrator || auth.currentRole?.role === Role.InstitutionPrincipal) &&
          <SidebarNavigationItem key="18"
            name={t("sidebar.institutions")}
            expanded={pathname.startsWith(institutionListRoute) || pathname === houseNumberInstitutionListRoute}
          >
            {getInstitutionItems()}
            {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
              || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader) &&
              getHouseNumberInstitutionItems()
            }
          </SidebarNavigationItem>
        }
        {/*ADMINISTRACIJA*/}
        {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
          || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader
          || auth.currentRole?.role === Role.InstitutionAdministrator || auth.currentRole?.role === Role.InstitutionPrincipal) &&
        <SidebarNavigationItem key="19"
          name={t("sidebar.administration")}
          expanded={false}
        >
            {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk) &&
              getAdministrationItems()
            }
          <SidebarNavigationItem key="20"
            name={t("sidebar.usersAndRoles")}
            expanded={pathname.startsWith(userRoleRoute)}
          >
            {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk) &&
              <SidebarNavigationItem key="21"
                name={t("sidebar.roles")}
                route={roleListRoute}
                url={roleListMatch?.url}
              >
                <RoleList />
              </SidebarNavigationItem>
            }
            {getUsersRolesItems()}
          </SidebarNavigationItem>
        </SidebarNavigationItem>
        }
        {/*STRUČNO POVJERENSTVO */}
        {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
          || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader
          || auth.currentRole?.role === Role.InstitutionPrincipal || auth.currentRole?.role === Role.InstitutionAdministrator
        ) &&
          <SidebarNavigationItem key="22"
            name={t("sidebar.committeeList")}
            expanded={pathname.startsWith(committeeListRoute)}
          >

            {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
              || auth.currentRole?.role === Role.InstitutionPrincipal || auth.currentRole?.role === Role.InstitutionAdministrator
            ) &&
              getCommitteeItems()
            }
            {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
              || auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader) &&
              [getCommitteeApprovalItems(),
              getCountyCommitteeItems()]
            }
            {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
                /* || auth.currentRole?.role === Role.MinistryAdministrator */) &&
              getMinistryCommitteeItems()
            }
          </SidebarNavigationItem>
        }
        {/*UNOS ZAHTJEVA*/}
        {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
          || ((auth.currentRole?.role === Role.CountyAdministrator || auth.currentRole?.role === Role.CountyLeader
          || auth.currentRole?.role === Role.InstitutionPrincipal || auth.currentRole?.role === Role.InstitutionAdministrator) && (auth.currentRole.locations?.length ?? 0) > 0)) &&
          <SidebarNavigationItem key="80"
            name={t("sidebar.requestList")}
            expanded={pathname.startsWith(requestListRoute)}
          >
            {getRequestItems()}
          </SidebarNavigationItem>
        }
        {/*OBRADA ZAHTJEVA*/}
        <SidebarNavigationItem key="90"
          name={t("sidebar.requestAdmin")}
          expanded={pathname.startsWith(requestAdminRoute)}
        >
          {getRequestAdminItems()}
          {(auth.currentRole?.role !== Role.MinistryAdministrator) &&
            [getOutsideEnrollmentAreaItems(),
            getLanguageCourseDecisionItems()]
          }
          {(auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk
            || auth.currentRole?.role === Role.MinistryAdministrator) &&
            getLanguageCourseDecisionMinistryItems()
          }
          {(auth.currentRole?.role !== Role.MinistryAdministrator) &&
            [getRegistrationFormItems(),
            getRegistrationItems()]
          }
        </SidebarNavigationItem>

        {/* HIDDEN ITEMS */}
        <SidebarNavigationItem key="100"
          name={t("navigation.faq")}
          route={faqGroupsAndItemsRoute}
          url={"/faq"}
          hideFromMenu={true}
        >
          <Faq />
        </SidebarNavigationItem>

        <SidebarNavigationItem key="101"
          name={t("navigation.aboutProgram")}
          route={aboutProgramRoute}
          url={"/aboutprogram"}
          hideFromMenu={true}
        >
          <AboutProgram />
        </SidebarNavigationItem>

        <SidebarNavigationItem key="102"
          name={t("navigation.helpAndSupport")}
          route={helpAndSupportRoute}
          url={"/help-and-support"}
          hideFromMenu={true}
        >
          <HelpAndSupport />
        </SidebarNavigationItem>

        <SidebarNavigationItem key="103"
          name={"error reporting"}
          route={newErrorReporRoute}
          url={errorReportMatch?.url}
          hideFromMenu={true} 
          // This opens in a new window. There doesn't appear to be 
          // any way to change it :(
        >
          <ErrorReportCreate />
        </SidebarNavigationItem>

        <SidebarNavigationItem key="104"
          name={t("navigation.statementOfAccessibility")}
          route={statementOfAccessibilityRoute}
          url={"statement-of-accessibility"}
          hideFromMenu={true}
        >
          <StatementOfAccessibility/>
        </SidebarNavigationItem>

      </SidebarNavigationContainer>
    </>
  )
}